import { PRICE_RANGE_TYPE, TAX_AND_FEE_INCLUSION_POLICY } from './constants';
import { getStayField } from './get-stay-field';

import type { PriceBand } from '@shared/types/frontend/ubff/price-band';
import type { Stay } from '@shared/types/utils';
import type { TaxAndFeeInclusionPolicy } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/common.pb';

export const buildAdditionalInfoPriceRangesInfo = ({
  atypicalDealsType,
  correlationId,
  currency,
  dayViewCorrelationId,
  entityId,
  indicativePrice,
  isWidgetSeen,
  priceBand,
  stay,
  taxAndFeeInclusionPolicy,
  type,
}: {
  indicativePrice: number;
  currency: string;
  type: string;
  taxAndFeeInclusionPolicy?: TaxAndFeeInclusionPolicy;
  correlationId?: string;
  dayViewCorrelationId?: string;
  stay: Stay;
  entityId?: string;
  isWidgetSeen: boolean;
  atypicalDealsType: string;
  priceBand: PriceBand;
}) => ({
  price_ranges_info: {
    indicative_price: {
      currency,
      amount: Math.ceil(indicativePrice),
      unit: 'WHOLE',
    },
    type: PRICE_RANGE_TYPE[type] || PRICE_RANGE_TYPE.UNSET_PRICE_RANGE_TYPE,
    correlation_id: correlationId,
    stay: getStayField(stay),
    entity_id: entityId && parseInt(entityId, 10),
    is_widget_seen: isWidgetSeen,
    day_view_correlation_id: dayViewCorrelationId,
    atypical_deals_type: atypicalDealsType,
    price_policy:
      TAX_AND_FEE_INCLUSION_POLICY[
        taxAndFeeInclusionPolicy || 'UNSET_PRICE_POLICY_TYPE'
      ],
    price_band: {
      high_range: {
        percentile: priceBand.pHigh.percentile,
        price: Math.ceil(priceBand.pHigh.price),
      },
      low_range: {
        percentile: priceBand.pLow.percentile,
        price: Math.ceil(priceBand.pLow.price),
      },
    },
  },
});
